import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelSetpointsList from './ModelSetpointsList';
import { getModelSetpoints, getUserOrgModelCategoryType, getUserProfileWidget,getModelCategorySetpoints } from '../../selectors/index';
import {
  getModelSetpointsThunk,
  describeModelSetpointsThunk,
  saveModelSetpointsThunk,
  setModelSetpointsChangeThunk,
  setModelSetpointShowScreenStatusThunk,
  setCurrentPage,
  setPageFilter,
  setModelSetpointsFilteredDataThunk
} from '../../actions/modelSetpoints';
import { getCurrentTimezone } from '../../selectors/index';

const mapStateToProps = state => {
  return {
    modelSetpoints: getModelSetpoints(state),
    currentTimezone: getCurrentTimezone(state),
    userProfileWidgets: getUserProfileWidget(state),
    userModelCategories: getUserOrgModelCategoryType(state),
    modelCategorySetpoints: getModelCategorySetpoints(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getModelSetpoints: (modelCategoryId, modelId) => getModelSetpointsThunk(modelCategoryId, modelId, 'MODELSETPOINTS'),
      saveModelSetpoint: (modelSetpoint, widgetCode) => saveModelSetpointsThunk(modelSetpoint, widgetCode),
      describeModelSetpoint: (modelId, modelSetpointId) => describeModelSetpointsThunk(modelId, modelSetpointId, 'MODELSETPOINTSEDIT'),
      changeModelSetpoint: selectedModelSetpoints => setModelSetpointsChangeThunk(selectedModelSetpoints),
      setModelSetpointShowScreenStatus: status => setModelSetpointShowScreenStatusThunk(status),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      setFilterData: filteredData => setModelSetpointsFilteredDataThunk(filteredData)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelSetpointsList);
